// src/components/forms/SurveyListResponseItem.js
import React from 'react';
import { UserCog, BarChart3, MessageSquare } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Button from './Button';

// Expects surveyInfo (matching SurveyInfo Pydantic model) and refreshData function
function SurveyListResponseItem({ surveyInfo, refreshData }) {
	const surveyTitleDisplay = surveyInfo?.title || 'Untitled Survey';
	const navigate = useNavigate();

	const handleAudienceConfigClick = () => {
		console.log(`Navigating to audience config for survey with ID: ${surveyInfo.survey_id}`);
		navigate(`/dashboard/audience/${surveyInfo.survey_id}`);
	};

	const handleResponseClick = () => {
		console.log(`Navigating to responses for survey with ID: ${surveyInfo.survey_id}`);
		navigate(`/dashboard/responses/${surveyInfo.survey_id}`);
	};

	const handleAnalyticsClick = () => {
		console.log(`Navigating to analytics for survey with ID: ${surveyInfo.survey_id}`);
		alert(`Analytics Not implemented yet`);
	};

	// Mock data for response stats - replace with actual API data later
	const mockStats = {
		totalResponses: 234,
		incompleteResponses: 18,
		activelyFilling: 7,
		countriesReached: 23
	};

	return (
		<div className='border shadow-sm rounded-lg p-6 flex flex-col h-full relative min-h-[280px]'>
			<div className='flex justify-between items-center'>
				<h2 className='text-lg font-semibold text-black flex-grow truncate'>{surveyTitleDisplay}</h2>
				<div className="flex items-center gap-1">
					<span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full">Active</span>
				</div>
			</div>

			<h3 className='text-sm text-gray-500 mt-1 mb-4'>
				ID: {surveyInfo.survey_id} - Created: {new Date(surveyInfo.created_at).toLocaleDateString()}
			</h3>

			<hr className='my-2'></hr>

			{/* Response Statistics */}
			<div className='flex-grow my-4'>
				<h4 className='text-md font-medium text-gray-700 mb-3'>Response Statistics</h4>
				<div className='grid grid-cols-2 gap-4'>
					<div className='bg-blue-50 p-3 rounded-lg'>
						<div className='text-2xl font-bold text-blue-600'>{mockStats.totalResponses}</div>
						<div className='text-sm text-blue-800'>Total Responses</div>
					</div>
					<div className='bg-yellow-50 p-3 rounded-lg'>
						<div className='text-2xl font-bold text-yellow-600'>{mockStats.incompleteResponses}</div>
						<div className='text-sm text-yellow-800'>Incomplete</div>
					</div>
					<div className='bg-green-50 p-3 rounded-lg'>
						<div className='text-2xl font-bold text-green-600'>{mockStats.activelyFilling}</div>
						<div className='text-sm text-green-800'>Currently Filling</div>
					</div>
					<div className='bg-purple-50 p-3 rounded-lg'>
						<div className='text-2xl font-bold text-purple-600'>{mockStats.countriesReached}</div>
						<div className='text-sm text-purple-800'>Countries Reached</div>
					</div>
				</div>
			</div>

			<hr className='my-2'></hr>

			{/* Action Buttons - All visible without dropdown */}
			<div className='flex justify-between items-center mt-auto gap-2'>
				{/* Primary Action - Responses */}
				<Button
					onClick={handleResponseClick}
					variant="primary"
					className="flex gap-2 items-center px-3 py-2 border rounded text-sm text-gray-700 hover:bg-gray-100 transition-colors"
				>
					<MessageSquare className='h-4 w-4'/> Responses
				</Button>

				{/* Secondary Actions */}
				<Button
					onClick={handleAnalyticsClick}
					variant="secondary"
					className="flex gap-2 items-center px-3 py-2 border rounded text-sm text-gray-700 hover:bg-gray-100 transition-colors"
				>
					<BarChart3 className='h-4 w-4'/> Analytics
				</Button>

				<Button
					onClick={handleAudienceConfigClick}
					variant="secondary"
					className="flex gap-2 items-center px-3 py-2 border rounded text-sm text-gray-700 hover:bg-gray-100 transition-colors"
				>
					<UserCog className='h-4 w-4'/> Audience
				</Button>
			</div>
		</div>
	);
}

export default SurveyListResponseItem;